import { Phone } from '../Model/Questionnaire'

export default class PhoneHelper {
    public static convertToString(phones: Array<Phone>): string {
        return phones.map((x: Phone) => `${x.number}`).join(' | ')
    }

    public static validatePhone(phoneNumber: string): boolean {
        let reg = /^[\\s]*[+]?[0-9()\-\\s]{4,17}[\\s]*$/g
        return !reg.test(phoneNumber)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/PhoneHelper.ts